import { render, staticRenderFns } from "./TopNotificationBar.vue?vue&type=template&id=6ebecb10&scoped=true&"
import script from "./TopNotificationBar.vue?vue&type=script&lang=js&"
export * from "./TopNotificationBar.vue?vue&type=script&lang=js&"
import style0 from "./TopNotificationBar.vue?vue&type=style&index=0&id=6ebecb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebecb10",
  null
  
)

export default component.exports